/**
 * Header Sticky Shrink Script
 * Adds sticky behavior and smooth shrink effect on scroll
 * Production-safe, performant implementation
 */

(function() {
  'use strict';

  // Disable sticky header on mobile (Android Chrome fix)
  if (window.matchMedia('(max-width: 767px)').matches) {
    return;
  }

  // Configuration
  const SHRINK_THRESHOLD = 100; // px scrolled before shrinking
  const SHRINK_CLASS = 'header--shrunk';

  // Elements
  const header = document.querySelector('.header--custom');
  if (!header) return;

  // State
  let isShrunk = false;
  let ticking = false;

  // Throttled scroll handler
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  function updateHeader() {
    const shouldShrink = window.scrollY > SHRINK_THRESHOLD;
    
    if (shouldShrink !== isShrunk) {
      header.classList.toggle(SHRINK_CLASS, shouldShrink);
      isShrunk = shouldShrink;
    }
    
    ticking = false;
  }

  // Initialize
  window.addEventListener('scroll', onScroll, { passive: true });
  
  // Check initial state
  updateHeader();
})();